import PropTypes from 'prop-types'

// This component displays the application version and last update date
// Both values are automatically updated during production deployments
// by the prepare-release.cjs script
export const Version = ({ type = 'version', className = '' }) => {
  // These values are updated automatically during release
  const VERSION_NUMBER = '1.33.15'
  const LAST_UPDATED = 'June 2026'

  if (type === 'version') {
    return <span className={`app-version ${className}`}>{VERSION_NUMBER}</span>
  }

  if (type === 'date') {
    return <span className={`app-last-updated ${className}`}>{LAST_UPDATED}</span>
  }

  return null
}

Version.propTypes = {
  type: PropTypes.oneOf(['version', 'date']),
  className: PropTypes.string,
}

export default Version
